import {Component, inject, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule, NgForm} from '@angular/forms';
import {PasswordValidationDirective} from '../../../validation/directives/password-validation-directive';
import {AuthService} from '../../../services/auth-service';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-register-component',
  imports: [
    FormsModule,
    PasswordValidationDirective
  ],
  templateUrl: './register-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './register-component.scss'
})
export class RegisterComponent implements OnDestroy{

  subscription: Subscription | null = null;
  error: string | undefined;

  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);

  constructor() {
    this.authService.isAuthenticated()
      .pipe(
        takeUntilDestroyed()
      )
      .subscribe(result => {
        if (result) {
          this.router.navigate(['/main']);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  register(form: NgForm) {
    this.error = undefined;
    if (form.valid) {
      this.subscription = this.authService.register(form.value.email, form.value.password, form.value.confirmation)
        .subscribe(result => {
          if (result.data) {
            this.router.navigate(['/main']);
          } else {
            this.error = result.error;
          }
        }
      );
    }
  }

}
